import Vue from "vue";
import VueRouter from "vue-router";
import HomeView from "../components/homePage";

import NProgress from "nprogress"; // 路由守卫
import "nprogress/nprogress.css";

Vue.use(VueRouter);

const routes = [
  // 可以不要home页面,直接定向到首页
  {
    path: "/",
    redirect: "/home",
  },
  {
    path: "/home",
    name: "home",
    component: HomeView,
  },
  // RBP 页面路由器
  {
    path: "/speciesRBP",
    name: "speciesRBP",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../components/RBPd/RBPpage.vue"),
  },
  // RBP 页面路由器
  {
    path: "/searh_all",
    name: "searh_all",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../components/searchAll.vue"),
  },
  // 家族页面路由器
  {
    path: "/family",
    name: "family",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../components/familyD/familyPage.vue"
      ),
  },
  {
    path: "/familySpecies",
    name: "familySpecies",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../components/familyD/familySpeciesPage.vue"
      ),
  },
  // 物种页面路由器
  {
    path: "/species",
    name: "species",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../components/speciesPage.vue"),
  },
  // 物种BRP详细页面
  {
    path: "/species_overview",
    name: "species_overview",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../components/speciesD/speciesDetails.vue"
      ),
  },
  // cancers 页面路由
  {
    path: "/cancers",
    name: "cancers",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../components/cancers/cancerPage.vue"
      ),
  },
  // genetic disease 页面路由
  {
    path: "/geneticDisease",
    name: "geneticDisease",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../components/geneticDisease/geneticDiseasePage.vue"
      ),
  },
  {
    path: "/geneticDiseaseGene",
    name: "geneticDiseaseGene",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../components/geneticDisease/geneticPerGene.vue"
      ),
  },
  // viruse 页面路由
  {
    path: "/virus",
    name: "virus",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../components/viruse/sarsCov2.vue"
      ),
  },
  // drugs 页面路由
  {
    path: "/drugs",
    name: "drugs",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../components/drugsD/drugsPage.vue"
      ),
  },
  // shRBP 页面路由
  {
    path: "/shRBP",
    name: "shRBP",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../components/shRBP/shRBPpage.vue"
      ),
  },
  // mfRBP 页面路由
  {
    path: "/mfRBP",
    name: "mfRBP",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../components/mfRBP/mfRBPPage.vue"
      ),
  },
  // interactome 页面路由
  {
    path: "/interactome",
    name: "interactome",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../components/interactomes/interactomePage.vue"
      ),
  },
  // CLIPseq 页面路由
  {
    path: "/rbpRNA",
    name: "rbpRNA",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../components/CLIPpage/CLIPpage.vue"
      ),
  },
  {
    path: "/rbpRNAdetails",
    name: "rbpRNAdetails",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../components/CLIPpage/CLIPdetails.vue"
      ),
  },
  // 工具 页面路由
  {
    path: "/RBPredictor",
    name: "RBPredictor",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../components/tools/RBPredictorPage.vue"
      ),
  },
  {
    path: "/Blast",
    name: "Blast",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../components/tools/blastPage.vue"
      ),
  },
  {
    path: "/dataset",
    name: "dataset",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../components/datasetPage.vue"),
  },
  {
    path: "/datasetDetails",
    name: "datasetDetails",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../components/datasetD/datasetDetails.vue"
      ),
  },
  {
    path: "/download",
    name: "download",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../components/downloadPage.vue"),
  },
  {
    path: "/helpDoc",
    name: "helpDoc",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../components/helpPage.vue"),
  },
];

const router = new VueRouter({
  // mode: "history",
  // base: process.env.BASE_URL,
  base: "/rbpworld",
  routes,
});

//路由守卫项
router.beforeEach((to, from, next) => {
  NProgress.start();
  next();
});

router.afterEach(() => {
  NProgress.done();
});

export default router;
